module.exports = __webpack_public_path__ + "assets/logo-white.19dec7d9.svg";